import React from "react";
import styles from "./HomeTopBar.module.scss";
import AppBar from "./weui/AppBar";

function HomeTopBar_Old({ assistantName }: { assistantName: string | null }) {
  return (
    <>
      <div className={styles.headerContainer}>
        <header className={styles.header}>
          <div className={styles.titleContainer}>
            <div className={styles.title}>{assistantName}</div>
          </div>
          {/* <div className={styles.iconContainer}>
            <svg
              className={styles.icon}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="11" cy="11" r="8"></circle>
              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
            <svg
              className={styles.icon}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
          </div> */}
        </header>
      </div>
    </>
  );
}

function HomeTopBar({ title }: { title: string | null }) {
  return (
    <>
      <AppBar
        title={title}
        showLeftBack={false}
        showRightMore={false}
      />
    </>
  );
}

export default HomeTopBar;
